import {User} from '@hconnect/apiclient'
import Assessment from '@mui/icons-material/Assessment'
import {useState} from 'react'

import {IconTextButton} from '../../components/IconTextButton'
import {useLoggedInUserPermissions, useLoggedInUserProfile} from '../../hooks/useLoggedInUser'
import {useTranslation} from '../../hooks/useTranslation'
import {Permission} from '../../modules/LoggedInUser'

import {AuditInformationDialog} from './dialogs/AuditInformationDialog'



export type ViewAuditButtonProps = {
  userIdentifier: string
  auditType: 'user' | 'roles'
  userCountry: string
  loggedInUserPermissions?: Permission[] | null
  loggedInUserProfile?: User | null
}

export const ViewAuditButton = ({
  auditType,
  userIdentifier,
  userCountry,
  loggedInUserPermissions,
  loggedInUserProfile
}: ViewAuditButtonProps) => {
  const {t} = useTranslation()
  const loggedInUserProfileData = useLoggedInUserProfile(loggedInUserProfile)
  const loggedInUserPermissionsData = useLoggedInUserPermissions(loggedInUserPermissions)

  const canViewAuditInformation = loggedInUserPermissionsData.some(
    (permission) =>
      permission.permissionType === 'VIEW_AUDIT' && 
      (permission.dataScope.countryId === userCountry ||
        loggedInUserProfileData?.hasRoles.includes('GLOBAL_ADMIN'))
  )

  const [isAuditDialogOpen, setShowAuditDialog] = useState(false)
  const handleCloseDialog = () => {
    setShowAuditDialog(false)
  }

  return (
    <>
      {isAuditDialogOpen && (
        <AuditInformationDialog
          userIdentifier={userIdentifier}
          auditType={auditType}
          onCloseAuditDialog={handleCloseDialog}
        />
      )}
      <IconTextButton
        label={t(auditType === 'user' ? 'audit.viewUserAudit' : 'audit.viewRoleAudit')}
        IconComponent={Assessment}
        onClick={() => setShowAuditDialog(true)}
        data-test-id="button-audit-information"
        hide={!canViewAuditInformation}
      />
    </>
  )
}
